import { createFileRoute, redirect } from "@tanstack/react-router";

// Former city pages were removed; old links permanently redirect to the homepage.
export const Route = createFileRoute("/locations/$")({
  loader: () => {
    throw redirect({ to: "/", statusCode: 301 });
  },
});
